let forgotForm = document.getElementById("forgot-form");
let ajaxUrl = glide_custom_data.ajax_url;
let forgotNonce = glide_custom_data.ajax_nonce;

if( forgotForm ) {
    forgotForm.addEventListener("submit", function (event) {
        event.preventDefault();
        
        $('#forgot-modal-trigger').click();

        let email = document.getElementById('email').value.trim();
        let emailValid = false;
        
        if( email == '' ) {
            emailValid = false;
            glide_ajax_loader_hide();
            $('.message-text').html('<p>Email is required</p>');
        } else {
            if( validateEmail(email) ) {
                emailValid = true;
            } else {
                emailValid = false;
                glide_ajax_loader_hide();
                $('.message-text').html('<p>Enter valid email</p>');
            }
        }
        
        if( emailValid ) {
            var formData = {
                action: "user_forgot_password",
                email: email,
                forgotNonce: forgotNonce,
            };

            glide_ajax_loader_show();

            jQuery.ajax({
                url: ajaxUrl,
                type: "POST",
                data: formData,
                success: function (response) {
                    glide_ajax_loader_hide();
                    if( response.success ) {
                        $('.message-text').html('<p>A link to reset <br> your password <br> has been emailed to <br> the address entered. <br>- The Glide Team -</p>');
                    } else {
                        if( response.data.message=='email' ) {
                            $('.message-text').html('<p>The email entered <br> does not match any <br> in our records. <br> Please try again or contact our system administrator.</p>');
                        }
                        if( response.data.message=='attack' ) {
                            $('.message-text').html('<p>Our system is facing <br> technical issues. <br> Please try again <br> in a few minutes</p>');
                        }
                    }
                },
                error: function () {
                    glide_ajax_loader_hide();
                    $('.message-text').html('<p>Our system is facing <br> technical issues. <br> Please try again <br> in a few minutes</p>');
                },
            });
        }

    });
}